import { useState, useContext } from "react";
import {
  Box,
  Grid,
  Table,
  TableRow,
  TableCell,
  TableBody,
  TableHead,
  TableContainer,
} from "@mui/material";
//Srcs
import "../../../Style/pagestyle.scss";
import EmptyData from "../../../Components/Include/EmptyData";
import LoadingPage from "../../../Utils/LoadingPage";

import { AuthContext } from "../../../Context/AuthContext";
import { ButtonCreate } from "../../../Utils/Component";
import { useGetEducationLevelPagination } from "../../../Hooks/useGetEducationLevelPagination";

import moment from "moment";
import useWithDimension from "../../../Hooks/useWithDimension";
import EducationLevelForm from "../../../Components/EducationLevel/Form/EducationLevelForm";
import EducationLevelAction from "../../../Components/EducationLevel/EducationLevelAction";

export default function TabEducationLevel() {
  const { t } = useContext(AuthContext);

  const [open, setOpen] = useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const queryParams = new URLSearchParams(window.location.search);
  const id = queryParams.get("id");
  
  const { refetch, loading, tableData } = useGetEducationLevelPagination({
    memberId: id,
  });

  // ======================= Resize width Screen ======================
  const { width } = useWithDimension();

  const levelData = [
    {
      value: "Postdoctoral Studies",
      label: t("thead_postdoctoral_studies"),
    },
    {
      value: "Doctor of Philosophy",
      label: t("thead_doctor_of_philosophy"),
    },
    {
      value: "Master's Degree",
      label: t("thead_masters_degree"),
    },
    {
      value: "Bachelor's Degree",
      label: t("thead_bachelor_degree"),
    },
    {
      value: "Associate Degree",
      label: t("thead_associate_degree"),
    },
    {
      value: "Professional Certifications",
      label: t("thead_professional_certifications"),
    },
    {
      value: "High School Diploma",
      label: t("thead_high_school_diploma"),
    },
    {
      value: "Secondary School",
      label: t("thead_secondary_school"),
    },
    {
      value: "Elementary School",
      label: t("thead_elementary_school"),
    },
  ];

  const getLabelByValue = (value) => {
    const item = levelData.find((level) => level.value === value);
    return item ? item.label : null;
  };

  return (
    <>
      <Box>
        <Grid container spacing={3}>
          <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
            <ButtonCreate
              handleOpen={handleOpen}
              classBtn={"btn-create"}
              classIcon={"icon-add"}
            />

            {open && (
              <EducationLevelForm
                open={open}
                handleClose={handleClose}
                setRefetch={refetch}
                dialogTitle="Create"
              />
            )}
          </Grid>
        </Grid>
      </Box>

      <Box className="body-container">
        <TableContainer sx={{ maxWidth: `${width}px` }}>
          <Table className="table" aria-label="simple table">
            <TableHead className="header-row ">
              <TableRow>
                <TableCell
                  className={t("class-name-header-title-start")}
                  width="4%"
                >
                  {t("no")}
                </TableCell>
                <TableCell className={t("class-name-header-title")}>
                  {t("thead_institute_or_university")}
                </TableCell>
                <TableCell className={t("class-name-header-title")}>
                  {t("thead_major")}
                </TableCell>
                <TableCell className={t("class-name-header-title")}>
                  {t("thead_level")}
                </TableCell>
                <TableCell className={t("class-name-header-title")}>
                  {t("thead_start_date")}
                </TableCell>
                <TableCell className={t("class-name-header-title")}>
                  {t("thead_end_date")}
                </TableCell>
                <TableCell
                  className={t("class-name-header-title-end")}
                  width="8%"
                ></TableCell>
              </TableRow>
            </TableHead>
            {loading ? (
              <TableBody className="body">
                <TableRow className="body-row">
                  <TableCell
                    colSpan={9}
                    className="body-cell"
                    sx={{ bgcolor: "#fff" }}
                  >
                    <LoadingPage />
                  </TableCell>
                </TableRow>
              </TableBody>
            ) : (
              <>
                {tableData?.length === 0 || tableData?.length === undefined ? (
                  <TableBody className="body">
                    <TableRow className="body-row">
                      <TableCell colSpan={9} className="body-cell">
                        <EmptyData />
                      </TableCell>
                    </TableRow>
                  </TableBody>
                ) : (
                  <>
                    <TableBody className="body">
                      {tableData?.map((row, index) => {
                        return (
                          <TableRow className="body-row" key={index}>
                            <TableCell className="body-cell-start">
                              {index + 1}
                            </TableCell>

                            <TableCell className="body-cell">
                              {row?.instituteOrUniversityId?.nameKh}
                            </TableCell>

                            <TableCell className="body-cell">
                              {row?.majorsId?.majorsNameKh}
                            </TableCell>

                            <TableCell className="body-cell">
                              {getLabelByValue(row?.level)}
                            </TableCell>

                            <TableCell className="body-cell">
                              {moment(row?.startDate).format("DD-MM-YYYY")}
                            </TableCell>

                            <TableCell className="body-cell">
                              {moment(row?.endDate).format("DD-MM-YYYY")}
                            </TableCell>

                            <TableCell className="body-cell-end" align="right">
                              <EducationLevelAction
                                editData={row}
                                setRefetch={refetch}
                              />
                            </TableCell>
                          </TableRow>
                        );
                      })}
                    </TableBody>
                  </>
                )}
              </>
            )}
          </Table>
        </TableContainer>
      </Box>
    </>
  );
}
